import { getApiClientErrorStatus } from './errors';

/**
 * Default retry: retry on 5xx server errors and non-API errors (e.g. network failures).
 * Don't retry 4xx client errors since they won't succeed on retry.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 3) return false;

  const status = getApiClientErrorStatus(error);
  if (status !== undefined) {
    return status >= 500;
  }

  return true;
}
